//@ts-nocheck

import React from "react"

import * as S from './MenuHightlight.styles'

import { Paragraph } from '../../../atoms/Typography/Typography.component'
import { SpacerBase } from "../../../atoms/GridSystem"
import Button from "../../../atoms/Button/Button.component"

interface MenuHighlightProps {
  preTitle?: string
  title?: string
  description?: string
  cta?: {
    href: string
    label: string
  }
}

const MenuHighlight = ({ preTitle, title, description, cta }: MenuHighlightProps) => {
  return (
    <S.MenuHighlight>
      { preTitle ? (
        <>
          <Paragraph content={preTitle} typo={'paragraphSM'} />
          <SpacerBase xs={1} />
        </>
      ) : null }
      { title ? (
        <>
          <Paragraph content={title} typo={'displaySM'} />
          <SpacerBase xs={2} />
        </>
      ) : null }
      { description ? (
        <>
          <Paragraph content={description} typo={'paragraphSM'} />
          <SpacerBase xs={2} />
        </>
      ) : null }
      { cta ? (
        <>
          <Button
            variant="primary"
            label={cta.label}
            href={cta.href}
            iconEnd={'arrow-right'}
            inheritedColorScheme={'green'}
          />
        </>
      ) : null }
    </S.MenuHighlight>
  )
}

export default MenuHighlight